import { cn } from '../../lib/cn';
import type { PrincipleRow } from '../../enterpriseaigovernance/framework';

type Props = { principles?: PrincipleRow[] };

export function AIPrinciplesPanel({ principles = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {principles.map((p) => (
        <div key={p.principle} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-sm font-medium">{p.principle}</p>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            p.enforced ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {p.status}
          </span>
        </div>
      ))}
    </div>
  );
}
